enum VoiceLanguage {
    ENG = 'v_eng',
    SCH = 'v_sch',
    TCH = 'v_tch',
    KR = 'v_ko',
    JP = 'v_ja',
    ID = 'v_id',
    ES = 'v_es',
    PT = 'v_pt',
    VI = 'v_vi',
    TH = 'v_th',
    MS = 'v_ms',
    FIL = 'v_fil',
    HI = 'v_hi',
}

// eslint-disable-next-line no-redeclare
namespace VoiceLanguage {
    export function i18nToVoiceLanguage(language: string): VoiceLanguage {
        return `v_${language}` as VoiceLanguage;
    }
    export function contains(language: string): language is VoiceLanguage {
        return Object.values(VoiceLanguage).includes(language as VoiceLanguage);
    }
    export function getAll(): VoiceLanguage[] {
        return Object.values(VoiceLanguage) as VoiceLanguage[];
    }
    Object.defineProperty(VoiceLanguage, 'contains', {
        enumerable: false,
    });
    Object.defineProperty(VoiceLanguage, 'getAll', {
        enumerable: false,
    });
}

export default VoiceLanguage;
